// =============================================================================
// CCM19 module
// =============================================================================

const updateEvent = new CustomEvent("asuc-updated");
const data = {
    v: null,
    acceptedEmbeddings: [],
};

const domReady = () => {
    return new Promise((resolve) => {
        if (document.readyState === "complete" || document.readyState === "interactive") {
            resolve();
        } else {
            document.addEventListener("DOMContentLoaded", () => {
                resolve();
            }, { once: true });
        }
    });
};

const checkCMVersion = () => {
    if (typeof CCM !== "undefined") data.v = 1;
};

export const getCMData = async () => {
    if (data.v === 1) data.acceptedEmbeddings = CCM.acceptedEmbeddings;
};

export const getEmbeddingAccepted = (name) => {
    if (data.v === 1) {
        // Return true if the embedding with the given id is accepted
        return (
            Array.isArray(data.acceptedEmbeddings) &&
            data.acceptedEmbeddings.some((e) => e.name === name)
        );
    }
};

export const checkCMInit = async () => {
    if (data.v === 1) return CCM.consent;
    return false;
};

export const acceptCMService = async (id) => {
    checkCMVersion();

    if (data.v === 1) CCM.openControlPanel();
};

export const init = () => {
    checkCMVersion();
    getCMData();

    let acceptBtns = document.querySelectorAll(".asuc-accept");
    acceptBtns.forEach((btn) => {
        btn.addEventListener("click", async () => {
            if (data.v === 1) CCM.openControlPanel();
        });
    });

    // get latest data on events
    const promise = domReady();
    promise.then(() => {
        document.dispatchEvent(updateEvent);
        if (data.v === 1) {
            window.addEventListener("ccm19WidgetLoaded", function (e) {
                getCMData();
                document.dispatchEvent(updateEvent);
            });
            window.addEventListener("ccm19EmbeddingAccepted", function (e) {
                getCMData();
                document.dispatchEvent(updateEvent);
            });
            window.addEventListener("ccm19WidgetClosed", function (e) {
                getCMData();
                document.dispatchEvent(updateEvent);
            });
        }
    });
};
